// extracted by mini-css-extract-plugin
module.exports = {"me":"categorie_me__l8SPI","tempImage":"categorie_tempImage__6eyfZ","title":"categorie_title__L7QER"};